import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { User } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditUser from './EditUser.vue';
    import ResetPassword from './ResetPassword.vue';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        user: User;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserTableActions',
  props: {
    user: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.user }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).USERS_UPDATE))
        ? (_openBlock(), _createBlock(EditUser, {
            key: 0,
            user: _ctx.user
          }, null, 8, ["user"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).USERS_UPDATE))
        ? (_openBlock(), _createBlock(ResetPassword, {
            key: 1,
            user: _ctx.user
          }, null, 8, ["user"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).USERS_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 2,
            route: _ctx.route('v2.users.destroy', _ctx.user.id),
            "query-key": [_unref(QueryKey).USERS],
            header: "users.js.delete.title",
            description: "users.js.delete.content"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})